<template>
    <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" label-width="120px">
            <el-form-item prop="username" :label="$t('user.username')">
                <el-input v-model="dataForm.username" :placeholder="$t('user.username')"></el-input>
            </el-form-item>
            <el-form-item prop="password" :label="$t('user.password')" :class="{ 'is-required': !dataForm.id }">
                <el-input v-model="dataForm.password" type="password" :placeholder="$t('user.password')"></el-input>
            </el-form-item>
            <el-form-item prop="comfirmPassword" :label="$t('user.comfirmPassword')" :class="{ 'is-required': !dataForm.id }">
                <el-input v-model="dataForm.comfirmPassword" type="password" :placeholder="$t('user.comfirmPassword')"></el-input>
            </el-form-item>
            <el-form-item prop="realName" :label="$t('user.realName')">
                <el-input v-model="dataForm.realName" :placeholder="$t('user.realName')"></el-input>
            </el-form-item>
            <el-form-item prop="gender" :label="$t('user.gender')" size="mini">
                <el-radio-group v-model="dataForm.gender">
                    <el-radio :label="0">{{ $t('user.gender0') }}</el-radio>
                    <el-radio :label="1">{{ $t('user.gender1') }}</el-radio>
                    <el-radio :label="2">{{ $t('user.gender2') }}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item prop="email" :label="$t('user.email')">
                <el-input v-model="dataForm.email" :placeholder="$t('user.email')"></el-input>
            </el-form-item>
            <el-form-item prop="mobile" :label="$t('user.mobile')">
                <el-input v-model="dataForm.mobile" :placeholder="$t('user.mobile')"></el-input>
            </el-form-item>
        </el-form>
        <template slot="footer">
            <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
        </template>
    </el-dialog>
</template>

<script>
    import debounce from "lodash/debounce";
    import { isEmail, isMobile } from '@/utils/validate'
    export default {
        name: "org-config-admin",
        data () {
            return {
                orgId:null,
                visible: false,
                roleList: [],
                roleIdListDefault: [],
                dataForm: {
                    id: '',
                    username: '',
                    deptId: '0',
                    deptName: '',
                    password: '',
                    comfirmPassword: '',
                    realName: '',
                    gender: 0,
                    email: '',
                    mobile: '',
                    orgId:null,
                    status: 1
                }
            }
        },
        computed: {
            dataRule () {
                var validatePassword = (rule, value, callback) => {
                    if (!this.dataForm.id && !/\S/.test(value)) {
                        return callback(new Error(this.$t('validate.required')))
                    }
                    callback()
                }
                var validateComfirmPassword = (rule, value, callback) => {
                    if (!this.dataForm.id && !/\S/.test(value)) {
                        return callback(new Error(this.$t('validate.required')))
                    }
                    if (this.dataForm.password !== value) {
                        return callback(new Error(this.$t('user.validate.comfirmPassword')))
                    }
                    callback()
                }
                var validateEmail = (rule, value, callback) => {
                    if (!isEmail(value)) {
                        return callback(new Error(this.$t('validate.format', { 'attr': this.$t('user.email') })))
                    }
                    callback()
                }
                var validateMobile = (rule, value, callback) => {
                    if (!isMobile(value)) {
                        return callback(new Error(this.$t('validate.format', { 'attr': this.$t('user.mobile') })))
                    }
                    callback()
                }
                return {
                    username: [
                        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
                    ],
                    password: [
                        { validator: validatePassword, trigger: 'blur' }
                    ],
                    comfirmPassword: [
                        { validator: validateComfirmPassword, trigger: 'blur' }
                    ],
                    orgId: [
                        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
                    ],
                    realName: [
                        { required: true, message: this.$t('validate.required'), trigger: 'blur' }
                    ],
                    mobile: [
                        { required: true, message: this.$t('validate.required'), trigger: 'blur' },
                        { validator: validateMobile, trigger: 'blur' }
                    ]
                }
            }
        },
        methods: {
            init(id) {
                this.visible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                    this.dataForm.orgId=id;
                    this.orgId=id;
                    Promise.all([
                        //this.getRoleList()
                    ]).then(() => {
                        if (this.orgId) {
                            this.getInfoByOrgId(this.orgId)
                        }
                    })
                })
            },
            // 获取信息
            getInfoByOrgId(orgId) {
                this.$http.get(`/sys/user/getByOrg/${orgId}`).then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.dataForm = {
                        ...this.dataForm,
                        ...res.data
                    }
                    if(this.dataForm.orgId===null || this.dataForm.orgId==='') {
                        this.dataForm.orgId=this.orgId;
                    }
                }).catch(() => {
                })
            },
            // 表单提交
            dataFormSubmitHandle: debounce(function () {
                this.$refs['dataForm'].validate((valid) => {
                    if (!valid) {
                        return false
                    }
                    this.$http[!this.dataForm.id ? 'post' : 'post']('/sys/user/saveSubAdmin', {
                        ...this.dataForm
                    }).then(({data: res}) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg)
                        }
                        this.$message({
                            message: this.$t('prompt.success'),
                            type: 'success',
                            duration: 500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    }).catch(() => {
                    })
                })
            }, 1000, {'leading': true, 'trailing': false})
        }
    }
</script>

<style scoped>

</style>
